import { render, staticRenderFns } from "./Sprc.vue?vue&type=template&id=0bf9dbd4&scoped=true&"
import script from "./Sprc.vue?vue&type=script&lang=js&"
export * from "./Sprc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf9dbd4",
  null
  
)

export default component.exports